/*
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-09-18 09:48:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-18 15:23:04
 */
/*
 * @Descripttion: 对菜单format
 * @Author: voanit
 * @Date: 2021-09-18 09:48:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-09-18 09:49:54
 */
import { deepClone } from '@/utils'
export const menuMap = (arrs, res) => {
  let menu = deepClone(arrs);
  let defaultBoardID = null;
  let defaultFolderID = null;
  let personalBoardID = null;
  let personalFolderID = null;
  let dataBoardID = null;
  let dataFolderID = null;
  try {
    // if (
    //   res &&
    //   res.status === 200 &&
    //   res.result &&
    //   res.result.data &&
    //   res.result.data.defaultBoard
    // ) {
    //   defaultBoardID = res.result.data.defaultBoard.boardID;
    //   defaultFolderID = res.result.data.defaultBoard.folderID;
    // }
    // if (
    //   res &&
    //   res.status === 200 &&
    //   res.result &&
    //   res.result.data &&
    //   res.result.data.personalFolder &&
    //   res.result.data.personalFolder.length
    // ) {
    //   personalBoardID =
    //     res.result.data.personalFolder[0] &&
    //     res.result.data.personalFolder.filter(item => !item.toUrl)[0]
    //       .boardID;
    //   personalFolderID =
    //     res.result.data.personalFolder[0] &&
    //     res.result.data.personalFolder[0].folderID;
    // }
    // if (
    //   res &&
    //   res.status === 200 &&
    //   res.result &&
    //   res.result.data &&
    //   res.result.data.merchantFolder &&
    //   res.result.data.merchantFolder.length
    // ) {
    //   dataBoardID =
    //     res.result.data.merchantFolder[0].boards[0] &&
    //     res.result.data.merchantFolder[0].boards.filter(
    //       item => !item.toUrl
    //     )[0].boardID;
    //   dataFolderID =
    //     res.result.data.merchantFolder[0].boards[0] &&
    //     res.result.data.merchantFolder[0].boards.filter(
    //       item => !item.toUrl
    //     )[0].folderID;
    // }

    // // 对非内部：如创乐，目录配置 -- start
    // if (
    //   res &&
    //   res.status === 200 &&
    //   res.result &&
    //   res.result.data &&
    //   res.result.data.personalFolder &&
    //   res.result.data.personalFolder.length
    // ) {
    //   const parentId = (menu.find(
    //     item => item.actionCode == 'shop-management::person-board-customer'
    //   ) || {}).actionId;
    //   if (parentId) {
    //     res.result.data.personalFolder.forEach(item => {
    //       if (!item.toUrl) {
    //         menu.push({
    //           actionCode: `shop-management::person-board-customer::${item.boardName}`,
    //           actionId: item.boardID,
    //           actionName: item.boardName,
    //           actionType: 1,
    //           adminFlag: true,
    //           isCustomer: true,
    //           parentId: parentId,
    //           url: `/person-board-main?boardID=${item.boardID}&folderID=${item.folderID}`,
    //           icon: '',
    //           isShow: 1,
    //           sort: 3,
    //           systemId: 3,
    //         });
    //       }
    //     });
    //   }

    // }
    // if (
    //   res &&
    //   res.status === 200 &&
    //   res.result &&
    //   res.result.data &&
    //   res.result.data.merchantFolder &&
    //   res.result.data.merchantFolder.length
    // ) {
    //   const parentId = (menu.find(
    //     item => item.actionCode == 'shop-management::data-board-customer'
    //   ) || {}).actionId;
    //   if (parentId) {
    //     res.result.data.merchantFolder[0].boards.forEach(item => {
    //       if (!item.toUrl) {
    //         menu.push({
    //           actionCode: `shop-management::data-board-customer::${item.boardName}`,
    //           actionId: item.boardID,
    //           actionName: item.boardName,
    //           actionType: 1,
    //           adminFlag: true,
    //           isCustomer: true,
    //           parentId: parentId,
    //           url: `/data-board-main?boardID=${item.boardID}&folderID=${item.folderID}`,
    //           icon: '',
    //           isShow: 1,
    //           sort: 12,
    //           systemId: 3,
    //         });
    //       }
    //     });
    //   }
    // }
    // // --end
    menu = menu.map(item => {
      if (
        item.actionCode === 'shop-management::dashboard-bi::person-board' &&
        personalBoardID
      ) {
        if (personalBoardID) {
          item.url = `/person-board?boardID=${personalBoardID}&folderID=${personalFolderID}`;
        } else {
          item.url = '/person-board';
        }
      } else if (
        item.actionCode === 'shop-management::dashboard-bi::default-board' &&
        defaultBoardID
      ) {
        item.url = `/default-board?boardID=${defaultBoardID}&folderID=${defaultFolderID}`;
      } else if (
        item.actionCode === 'shop-management::dashboard-bi::data-board' &&
        dataBoardID
      ) {
        if (dataBoardID) {
          item.url = `/data-board?boardID=${dataBoardID}&folderID=${dataFolderID}`;
        } else {
          item.url = '/data-board';
        }
      }
      return item;
    });
    // 设置菜单唯一键值
    menu = menu.map(item => {
      if (item.url) {
        let action = item.actionCode.split('::')
        const name = action[action.length - 1] + '::' + item.actionId
        const hasQuery = item.url.indexOf('?') > -1
        item.url = hasQuery ? item.url + `&actionId=${name}` : item.url + `?actionId=${name}`
      }
      return item
    })

  } catch (e) {
    console.log(e);
  }
  return menu
}

